import Icon from '../components/Icon.vue'

Icon.register({"fast-backward":{"width":512,"height":512,"paths":[{"d":"M0 436V76C0 69.4 5.4 64 12 64H52C58.6 64 64 69.4 64 76V227.9L235.5 71.4C256.1 54.3 288 68.6 288 96V227.9L459.5 71.4C480.1 54.3 512 68.6 512 96V416C512 443.4 480.1 457.7 459.5 440.6L288 285.3V416C288 443.4 256.1 457.7 235.5 440.6L64 285.3V436C64 442.6 58.6 448 52 448H12C5.4 448 0 442.6 0 436z"}]}})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/fast-backward.js
// module id = ixYH
// module chunks = 0